module.exports = __webpack_public_path__ + "img/collection2@2x.7db104b1.png";